export const GET_MEDIAS = "GET_MEDIAS";
export const GET_MEDIA_BY_ID = "GET_MEDIA_BY_ID";
export const UPDATE_MEDIA = "UPDATE_MEDIA";
export const DELETE_MEDIA = "DELETE_MEDIA";
export const CREATE_MEDIA = "CREATE_MEDIA";
